import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _descriptor2, _CategoriesDisplay, _CategoriesDisplay_brand;
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateGetter(s, r, a) { return a(_assertClassBrand(s, r)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import Component from "@glimmer/component";
import { hash } from "@ember/helper";
import { service } from "@ember/service";
import CategoriesAndLatestTopics from "discourse/components/categories-and-latest-topics";
import CategoriesAndTopTopics from "discourse/components/categories-and-top-topics";
import CategoriesBoxes from "discourse/components/categories-boxes";
import CategoriesBoxesWithTopics from "discourse/components/categories-boxes-with-topics";
import CategoriesOnly from "discourse/components/categories-only";
import CategoriesWithFeaturedTopics from "discourse/components/categories-with-featured-topics";
import ConditionalLoadingSpinner from "discourse/components/conditional-loading-spinner";
import LoadMore from "discourse/components/load-more";
import PluginOutlet from "discourse/components/plugin-outlet";
import SubcategoriesWithFeaturedTopics from "discourse/components/subcategories-with-featured-topics";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
const mobileCompatibleViews = ["categories_with_featured_topics", "subcategories_with_featured_topics"];
const subcategoryComponents = {
  boxes_with_featured_topics: CategoriesBoxesWithTopics,
  boxes: CategoriesBoxes,
  rows_with_featured_topics: CategoriesWithFeaturedTopics,
  rows: CategoriesOnly
};
const globalComponents = {
  categories_and_latest_topics_created_date: CategoriesAndLatestTopics,
  categories_and_latest_topics: CategoriesAndLatestTopics,
  categories_and_top_topics: CategoriesAndTopTopics,
  categories_boxes_with_topics: CategoriesBoxesWithTopics,
  categories_boxes: CategoriesBoxes,
  categories_only: CategoriesOnly,
  categories_with_featured_topics: CategoriesWithFeaturedTopics,
  subcategories_with_featured_topics: SubcategoriesWithFeaturedTopics
};
let CategoriesDisplay = (_class = (_CategoriesDisplay_brand = /*#__PURE__*/new WeakSet(), (_CategoriesDisplay = class CategoriesDisplay extends Component {
  constructor() {
    super(...arguments);
    _classPrivateMethodInitSpec(this, _CategoriesDisplay_brand);
    _initializerDefineProperty(this, "siteSettings", _descriptor, this);
    _initializerDefineProperty(this, "site", _descriptor2, this);
  }
  get categoriesComponent() {
    if (this.args.parentCategory) {
      return _classPrivateGetter(_CategoriesDisplay_brand, this, _get_componentForSubcategories);
    } else {
      return _classPrivateGetter(_CategoriesDisplay_brand, this, _get_globalComponent);
    }
  }
  get canLoadMore() {
    return this.site.lazy_load_categories && this.args.loadMore;
  }
}, setComponentTemplate(createTemplateFactory(
/*
  
    <PluginOutlet
      @name="above-discovery-categories"
      @connectorTagName="div"
      @outletArgs={{hash categories=@categories topics=@topics}}
    />
    {{#if this.canLoadMore}}
      <LoadMore
        @selector=".category:not(.muted-categories *)"
        @action={{@loadMore}}
      >
        <this.categoriesComponent
          @categories={{@categories}}
          @topics={{@topics}}
        />
        <ConditionalLoadingSpinner @condition={{@loadingMore}} />
      </LoadMore>
    {{else}}
      <this.categoriesComponent
        @categories={{@categories}}
        @topics={{@topics}}
      />
    {{/if}}
  
*/
{
  "id": "kcdr7TWA",
  "block": "[[[1,\"\\n    \"],[8,[32,0],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"above-discovery-categories\",\"div\",[28,[32,1],null,[[\"categories\",\"topics\"],[[30,1],[30,2]]]]]],null],[1,\"\\n\"],[41,[30,0,[\"canLoadMore\"]],[[[1,\"      \"],[8,[32,2],null,[[\"@selector\",\"@action\"],[\".category:not(.muted-categories *)\",[30,3]]],[[\"default\"],[[[[1,\"\\n        \"],[8,[30,0,[\"categoriesComponent\"]],null,[[\"@categories\",\"@topics\"],[[30,1],[30,2]]],null],[1,\"\\n        \"],[8,[32,3],null,[[\"@condition\"],[[30,4]]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"]],[]],[[[1,\"      \"],[8,[30,0,[\"categoriesComponent\"]],null,[[\"@categories\",\"@topics\"],[[30,1],[30,2]]],null],[1,\"\\n\"]],[]]],[1,\"  \"]],[\"@categories\",\"@topics\",\"@loadMore\",\"@loadingMore\"],false,[\"if\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/components/discovery/categories-display.js",
  "scope": () => [PluginOutlet, hash, LoadMore, ConditionalLoadingSpinner],
  "isStrictMode": true
}), _CategoriesDisplay), _CategoriesDisplay)), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "siteSettings", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "site", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
function _get_componentForSubcategories(_this) {
  const parentCategory1 = _this.args.parentCategory;
  const style1 = parentCategory1.subcategory_list_style;
  const component1 = subcategoryComponents[style1];
  if (!component1) {
    // eslint-disable-next-line no-console
    console.error("Unknown subcategory list style: " + style1);
    return CategoriesOnly;
  }
  return component1;
}
function _get_globalComponent(_this2) {
  let style1 = _this2.siteSettings.desktop_category_page_style;
  if (_this2.site.mobileView && !mobileCompatibleViews.includes(style1)) {
    style1 = mobileCompatibleViews[0];
  }
  const component1 = globalComponents[style1];
  if (!component1) {
    // eslint-disable-next-line no-console
    console.error("Unknown category list style: " + style1);
    return CategoriesOnly;
  }
  return component1;
}
export { CategoriesDisplay as default };